import React, { useContext } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "@asosteam/asos-web-react-i18n";
import StoreDataContext from "src/app/context/store-data";
import InfoMessage from "src/app/components/InfoMessage";

const URLS = {
  AU: "https://www.asos.com/au/customer-care/technical/i-cant-sign-into-my-account-what-should-i-do/",
  COM: "https://www.asos.com/customer-care/technical/im-having-trouble-signing-into-my-account/",
  DE: "https://www.asos.com/de/kundenservice/technisch/ich-kann-mich-nicht-in-meinem-asos-kundenkonto-anmelden/",
  DK: "https://www.asos.com/dk/kundeservice/teknisk/jeg-har-problemer-med-at-logge-ind-paa-min-konto/",
  ES: "https://www.asos.com/es/atencion-al-cliente/soporte-tecnico/no-puedo-acceder-a-mi-cuenta-que-puedo-hacer/",
  FR: "https://www.asos.com/fr/service-client/questions-techniques/que-faire-si-je-narrive-pas-a-me-connecter-a-mon-compte-/",
  IT: "https://www.asos.com/it/assistenza-clienti/assistenza-tecnica/non-riesco-ad-accedere-al-mio-account/",
  NL: "https://www.asos.com/nl/klantenservice/technisch/ik-heb-problemen-met-het-inloggen-op-mijn-account/",
  PL: "https://www.asos.com/pl/obsluga-klienta/kwestie-techniczne/mam-problem-z-logowaniem-sie-na-swoje-konto/",
  RU: "https://www.asos.com/ru/центр-поддержки/технические-вопросы/почему-я-не-могу-открыть-мой-личный-кабинет/",
  SE: "https://www.asos.com/se/kundservice/tekniskt/jag-har-problem-med-att-logga-in-pa-mitt-konto/",
  US: "https://www.asos.com/us/customer-care/technical/im-having-trouble-logging-into-my-account-what-should-i-do/",
};

function ChatBotIdentityErrorMessage({ formatTranslation }) {
  const { storeCode } = useContext(StoreDataContext);
  const url = URLS[storeCode] || URLS["COM"];

  return (
    <InfoMessage>
      <p>{formatTranslation("cchp_chat_bot_identity_error_title")}</p>
      <ul>
        <li>{formatTranslation("cchp_chat_bot_identity_error_first_line")}</li>
        <li>{formatTranslation("cchp_chat_bot_identity_error_second_line")}</li>
        <li>{formatTranslation("cchp_chat_bot_identity_error_third_line")}</li>
        <li>{formatTranslation("cchp_chat_bot_identity_error_fourth_line")}</li>
        <li>
          <a href={url}>
            {formatTranslation("cchp_chat_bot_identity_error_fifth_line")}
          </a>
        </li>
      </ul>
    </InfoMessage>
  );
}

ChatBotIdentityErrorMessage.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
};

export default withTranslation(ChatBotIdentityErrorMessage);
